import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import logo1 from '../../assets/1x/icone.png';
import { Facebook02Icon, NewTwitterIcon, Linkedin02Icon, InstagramIcon } from 'hugeicons-react';
import { PathLink } from '../../utils/PathLink';

function Footer() {
    const { t } = useTranslation();

    const dates = new Date();

    return (
        <footer className="relative bg-white overflow-hidden">
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
                    <div className="relative w-full h-full">
                        <svg
                            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] max-w-none opacity-[0.03]"
                            viewBox="0 0 1200 400"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <text
                                x="50%"
                                y="50%"
                                textAnchor="middle"
                                dominantBaseline="middle"
                                className="text-[180px] font-black fill-current text-gray-900"
                                style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
                            >
                                CCCA
                            </text>
                        </svg>
                    </div>
                </div>

                <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
                    <div className="relative w-full h-full">
                        <svg
                            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] max-w-none opacity-[0.025] rotate-6"
                            viewBox="0 0 800 300"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <text
                                x="50%"
                                y="50%"
                                textAnchor="middle"
                                dominantBaseline="middle"
                                className="text-[120px] font-bold fill-current text-primary"
                                style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
                            >
                                {/* CCCA */}
                            </text>
                        </svg>
                    </div>
                </div>

                <div className="absolute inset-0">
                    <svg
                        className="absolute bottom-0 left-0 w-full h-full opacity-[0.04]"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <defs>
                            <pattern
                                id="ccca-pattern"
                                x="0"
                                y="0"
                                width="60"
                                height="60"
                                patternUnits="userSpaceOnUse"
                            >
                                <path
                                    d="M30 0 L30 60 M0 30 L60 30"
                                    stroke="currentColor"
                                    strokeWidth="0.8"
                                    fill="none"
                                />
                                <circle
                                    cx="30"
                                    cy="30"
                                    r="4"
                                    stroke="currentColor"
                                    strokeWidth="0.6"
                                    fill="none"
                                />
                                <path
                                    d="M30 10 L30 20 M30 40 L30 50 M10 30 L20 30 M40 30 L50 30"
                                    stroke="currentColor"
                                    strokeWidth="0.5"
                                    fill="none"
                                />
                            </pattern>
                        </defs>
                        <rect width="100%" height="100%" fill="url(#ccca-pattern)" />
                    </svg>
                </div>

                <div className="absolute inset-0">
                    <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/5 to-transparent rotate-12 scale-150" />
                    <div className="absolute bottom-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/5 to-transparent -rotate-6 scale-150" />
                    <div className="absolute top-2/3 right-0 w-full h-px bg-gradient-to-r from-transparent via-primary/5 to-transparent rotate-45 scale-150" />
                </div>

                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0)_0%,rgba(255,255,255,0.3)_100%)]" />
            </div>

            <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
                <span className="text-[20rem] max-xl:text-[15rem] max-lg:text-[12rem] max-md:text-[8rem] font-black tracking-widest opacity-5">
                    <span className="text-primary">C</span>
                    <span className="text-primary">C</span>
                    <span className="text-primary">C</span>
                    <span className="text-secondary">A</span>
                </span>
            </div>

            <div className="relative z-10 px-[5%] py-16 max-md:py-12">
                <div className='grid grid-cols-4 gap-8 pb-10 max-lg:grid-cols-2 max-md:grid-cols-2 max-sm:grid-cols-1 border-b border-gray-200'>

                    <div className='mt-3'>
                        <Link to={PathLink()} className='flex items-center gap-3 max-md:gap-2'>
                            <img src={logo1} alt='CCCA Logo' width={50} height={50} className='images' id="images" />
                            <div className='flex flex-col font-bold text-start'>
                                <span className='text-[1.1rem] max-md:text-[1rem] text-gray-800'>{t('chamber')}</span>
                                <span className='text-[1.1rem] max-md:text-[1rem] text-primary'>{t('canada_africa')}</span>
                            </div>
                        </Link>
                        <p className='text-sm text-gray-600 mt-4 leading-relaxed max-w-xs'>
                            {t('footdes')}
                        </p>
                        <div className='flex items-center gap-3 mt-5'>
                            <Link to='#' className='w-[38px] h-[38px] flex justify-center items-center rounded-full bg-gray-100 text-gray-700 hover:bg-secondary hover:text-white transition-all duration-300 hover:scale-110'>
                                <Facebook02Icon size={18} />
                            </Link>
                            <Link to='#' className='w-[38px] h-[38px] flex justify-center items-center rounded-full bg-gray-100 text-gray-700 hover:bg-secondary hover:text-white transition-all duration-300 hover:scale-110'>
                                <NewTwitterIcon size={18} />
                            </Link>
                            <Link to='https://www.linkedin.com/company/chambre-de-commerce-canada-afrique/' className='w-[38px] h-[38px] flex justify-center items-center rounded-full bg-gray-100 text-gray-700 hover:bg-secondary hover:text-white transition-all duration-300 hover:scale-110'>
                                <Linkedin02Icon size={18} />
                            </Link>
                            <Link to='#' className='w-[38px] h-[38px] flex justify-center items-center rounded-full bg-gray-100 text-gray-700 hover:bg-secondary hover:text-white transition-all duration-300 hover:scale-110'>
                                <InstagramIcon size={18} />
                            </Link>
                        </div>
                    </div>

                    <div className='mt-3'>
                        <h5 className='m-0 mb-4 text-[1.1rem] font-semibold text-gray-800'>{t('links')}</h5>
                        <ul className='text-[0.9rem] font-normal flex flex-col gap-3'>
                            <li><NavLink to={PathLink('/Devenir-membre')} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('become_member')}</NavLink></li>
                            <li><NavLink to={PathLink('/Apropos-de-nous/Présentation')} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('about_us')}</NavLink></li>
                            <li><NavLink to={PathLink('/Evenements')} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('our_events')}</NavLink></li>
                            <li><a href='#contact' className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('contact')}</a></li>
                            <li><NavLink to={PathLink('/Actualites')} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('news')}</NavLink></li>
                            <li><NavLink to={PathLink('/CCCA REVUE')} className='text-gray-600 hover:text-secondary transition-colors duration-300'>CCCA REVUE</NavLink></li>
                            <li><NavLink to={PathLink('/nos-experts/leadership')} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('our_experts')}</NavLink></li>
                        </ul>
                    </div>

                    <div className='flex flex-col mt-3'>
                        <h5 className='m-0 mb-4 text-[1.1rem] font-semibold text-gray-800'>{t('purchasing_center')}</h5>
                        <ul className='text-[0.9rem] font-normal flex flex-col gap-3'>
                            <li><Link to={'/Avantage_membre'} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('our_products')}</Link></li>
                            <li><Link to={'Devenir_benevole'} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('registered_suppliers')}</Link></li>
                            <li><Link to={'/nouvelle_des_membres'} className='text-gray-600 hover:text-secondary transition-colors duration-300'>{t('buyers')}</Link></li>
                        </ul>
                    </div>

                    <div className='flex flex-col mt-3'>
                        <h5 className='m-0 mb-4 text-[1.1rem] font-semibold text-gray-800'>{t('newsletter')}</h5>
                        <span className='text-[0.9rem] font-normal text-gray-600 mb-4'>{t('newsletter_info')}</span>
                        <div className='flex items-center w-full overflow-hidden bg-gray-100 rounded-lg border border-gray-200 focus-within:border-secondary focus-within:ring-2 focus-within:ring-secondary/20 transition-all duration-300'>
                            <input
                                className='px-4 py-3 text-sm bg-transparent w-full outline-0 border-0 text-gray-800 placeholder-gray-400'
                                type='text'
                                placeholder={t('enter_email')}
                            />
                            <button className='flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-secondary hover:bg-secondary/90 transition-all duration-300 whitespace-nowrap'>
                                {t('subscribe')}
                            </button>
                        </div>
                        <p className='text-xs text-gray-500 mt-3'>
                            {t('privacy_consent')}
                        </p>
                    </div>
                </div>

                <div className='flex items-center justify-between gap-3 pt-6 max-md:flex-col max-md:justify-center'>
                    <span className='text-[0.85rem] max-md:text-[0.82rem] text-gray-600'>
                        &copy; {dates.getFullYear()} - {t('chamber_full')}
                    </span>
                    <div className='flex items-center gap-6 text-[0.8rem]'>
                        <Link className='text-gray-500 hover:text-secondary transition-colors duration-300' to={'/policy'}>{t('privacy_policy')}</Link>
                        <Link className='text-gray-500 hover:text-secondary transition-colors duration-300' to={'/plan'}>{t('site_map')}</Link>
                    </div>
                </div>

                <div className='flex justify-center items-center pt-4 mt-4 border-t border-gray-200'>
                    <NavLink
                        className='flex gap-1 text-[0.8rem] text-gray-500 items-center hover:text-secondary transition-colors duration-300'
                        to={'http://franchise-it-tech.com/'}
                    >
                        &copy; {t('designed_by')} <span className='font-bold text-gray-700 hover:text-secondary transition-colors duration-300'>Franchise-IT</span>
                    </NavLink>
                </div>
            </div>
        </footer>
    );
}

export default Footer;